module.exports = __webpack_public_path__ + "img/mullins-interior-art-collector.4be3ef75.jpg";